import { FormGroup } from '@angular/forms';

/**
 * Maps API validation errors (422 responses) to form controls.
 *
 * @param form - The form group containing the controls to map errors to
 * @param errors - Record of field names to error message arrays from the API
 *
 * @example
 * ```ts
 * this.service.updateUser(userId, request).subscribe({
 *   error: (err: HttpErrorResponse) => {
 *     if (err.status === 422 && err.error?.errors) {
 *       mapValidationErrorsToForm(this.form, err.error.errors);
 *     }
 *   }
 * });
 * ```
 */
export function mapValidationErrorsToForm(
  form: FormGroup,
  errors: Record<string, string[]>
): void {
  for (const [field, messages] of Object.entries(errors)) {
    const control = form.get(field);
    if (control) {
      control.setErrors({ apiError: messages[0] });
      control.markAsTouched();
    }
  }
}
